import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import DeletedSuccessfully from "./DeletedSuccessfully";
import { deleteParent } from "../../AxiosRtk/AddNewParent";
import Swal from "sweetalert2";
import useLangTranslation from "../../../customHooks/languageProvider";
import { setShowMessage } from "../../AxiosRtk/successMessage";
import { useDispatch } from "react-redux";

const DeleteAccount = ({
  showModal,
  closeModal,
  setLoading,
  loading,
  getAllParentData,
  parentId,
}) => {
  const dispatch = useDispatch();
  const [showDeletedModal, setShowDeletedModal] = useState(false);
  const { getLangTranslation } = useLangTranslation();

  const openDeletedModal = () => {
    setShowDeletedModal(true);
  };

  const closeDeletedModal = () => {
    setShowDeletedModal(false);
  };

  const handleDelete = async () => {
    try {
      setLoading(true);
      const req = {
        id: parentId?.ID,
      };
      const { data } = await deleteParent(req);
      if (data) {
        setTimeout(() => {
          dispatch(
            setShowMessage({
              showMessage: true,
              defaultMessage: data?.message,
              message: data?.message,
            })
          );
        }, 800);

        closeModal();
        
        // If you want to reload after successful deletion, you can still call `getAllParentData()` here
        getAllParentData(); // Optionally trigger reload after successful delete
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  return (
    <>
      <Modal show={showModal} size="sm" className="custom-modal blur-bg" centered>
        <Modal.Header>
          <div className="border-0 pb-0 d-flex justify-content-between w-100">
            <h6 className="modal-title text-blue-900">
              {getLangTranslation("DELETE_PARENT", "Delete parent")}
            </h6>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={closeModal} // Close modal without triggering reload
            ></button>
          </div>
        </Modal.Header>
        <Modal.Body className="py-1 px-4">
          <div className="modal-body">
            <h5 className="text-center mb-3">
              {getLangTranslation(
                "ARE_YOU_SURE_WANT_DELETE_ADDITIONAL_PARENT_ACC",
                "Are you sure want to delete this additional parent account"
              )}
            </h5>
            <div className="grid gap-3">
              <button
                className="btn btn-outline-primary g-col-6"
                type="button"
                onClick={closeModal} // Only close the modal on cancel
                disabled={loading}
              >
                <span className="btn-upper-case">
                  {getLangTranslation("CANCEL", "CANCEL")}
                </span>
              </button>
              <button
                className="btn btn-primary g-col-6"
                type="button"
                onClick={handleDelete} // Call the delete API when clicked
                disabled={loading}
              >
                <span className="btn-upper-case">
                  {getLangTranslation("DELETE", "DELETE")}
                </span>
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <DeletedSuccessfully
        showDeletedModal={showDeletedModal}
        closeDeletedModal={closeDeletedModal}
      />
    </>
  );
};

export default DeleteAccount;
